import { render, staticRenderFns } from "./batchChannelContract.vue?vue&type=template&id=886137bc&scoped=true&"
import script from "./batchChannelContract.vue?vue&type=script&lang=js&"
export * from "./batchChannelContract.vue?vue&type=script&lang=js&"
import style0 from "./batchChannelContract.vue?vue&type=style&index=0&id=886137bc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "886137bc",
  null
  
)

export default component.exports